export default "__VITE_ASSET__CzfObFVe__"